<app-section-wrapper-container>
	<form
		class="um-section-parent-container"
		[formGroup]="detailsForm"
		(keypress)="onKeyPress($event)">
		<app-searchable-field
			formControlName="vehicleCategoryId"
			(onSelectedItem)="selectedItem.set($event)" />
	</form>
</app-section-wrapper-container>
